import { createSelector } from 'reselect';

import {
  sumBy,
  result,
  find,
  sortBy,
  filter,
  isArray,
  groupBy,
  remove,
  uniqBy,
} from 'lodash';
import { categoryDefault, DMNGANH } from '../storages';

export const getMessage = (state, props) => {
  const { setting } = state.client;
  const { listMessage } = state.priceBoard;

  const lang = setting.lang || 'vi';
  const msg = listMessage[props.data.messageNo];
  console.log(msg);
  if (msg) {
    return msg[lang];
  }

  return props.data.message || 'Có lỗi trong quá trình xử lý. Hãy thử lại sau!';
};

export const getConfig = (state) => state.client.config;

const getSetting = (state) => state.client.setting;
const getToken = (state) => state.client.token;
const getAuth = (state) => state.client.auth;
const getCategory = (state) => {
  let _cat;
  if (
    !state.client ||
    !state.client.category ||
    !isArray(state.client.category) ||
    !state.client.category.length
  )
    _cat = categoryDefault;
  else _cat = state.client.category;

  // return _cat;

  // console.log(_cat)

  remove(_cat, (o) => o.groupName === 'LOLE');
  remove(_cat, (o) => o.groupName === 'NGANH');
  _cat = [
    ..._cat,
    {
      name: 'Trái phiếu',
      path: '/home/bang-gia/trai-phieu',
      groupName: 'TRAIPHIEU',
      type: 'group',
      value: [],
      pinnedRow: [],
    },
    {
      name: 'HSX',
      path: '/home/bang-gia/lo-le-hose',
      groupName: 'LOLE',
      type: 'group',
      value: [],
      pinnedRow: [],
    },
    {
      name: 'HNX',
      path: '/home/bang-gia/lo-le-hnx',
      groupName: 'LOLE',
      type: 'group',
      value: [],
      pinnedRow: [],
    },
    {
      name: 'Ngành',
      path: '/home/bang-gia/danh-muc-nganh',
      groupName: 'NGANH',
      type: 'group',
      value: [],
      pinnedRow: [],
    },
  ];

  return _cat;
};
const getToast = (state) => state.client.toast;
// const getConfig = (state) => state.client.config;

const getReceive1101 = (state) => state.socket.receive1101;
const getReceive3211 = (state) => state.socket.receive3211;
const getReceive3220 = (state) => state.socket.receive3220;
const getListAccount = (state) => state.socket.listAccount;
const getDefaultAccount = (state) => state.socket.defaultAccount;
const getOrderList = (state) => state.socket.orderList;
const getListOrder = (state) => state.socket.listOrder;
const getEventOrder = (state) => state.socket.event;
// TODO: 02/12/2020 update get socket status
const getSocketStatus = (state) => state.socket.serverStatus;

const getNewOrder = (state) => {
  return {
    newOrder: state.privData.newOrder ? state.privData.newOrder.data : null,
    newOrderSuccess: state.privData.newOrderSuccess,
    newOrderErrors: state.privData.newOrderErrors,
  };
};
const getEditOrder = (state) => {
  return {
    editOrder: state.privData.editOrder ? state.privData.editOrder.data : null,
    editOrderSuccess: state.privData.editOrderSuccess,
    editOrderErrors: state.privData.editOrderErrors,
  };
};
const getCancelOrder = (state) => {
  return {
    cancelOrder: state.privData.cancelOrder
      ? state.privData.cancelOrder.data
      : null,
    cancelOrderSuccess: state.privData.cancelOrderSuccess,
    cancelOrderErrors: state.privData.cancelOrderErrors,
  };
};
const getCashBalance = (state) => {
  if (state.privData.cashBalance) return state.privData.cashBalance.data;

  return null;
};
const getStockBalance = (state) => {
  if (state.privData.stockBalance) return state.privData.stockBalance.data;

  return null;
};
const getPositions = (state) => {
  if (state.privData.positions) return state.privData.positions.data;

  return null;
};
const getPurchasePower = (state) => {
  if (state.privData.purchasePower) return state.privData.purchasePower.data;

  return null;
};
const getSymbolInfo = (state) => {
  // console.log(state.privData.symbolInfo)
  if (state.privData.symbolInfo) return state.privData.symbolInfo.data.list[0];

  return null;
};

const getSymbolMargin = (state) => {
  // console.log(state.privData.symbolInfo)
  if (state.privData.symbolInfo) return state.privData.symbolInfo.dataMargin;

  return null;
};

const getMatchOrder = (state) => {
  if (state.privData.matchOrder) return state.privData.matchOrder.data;

  return null;
};

const getStockDetail = (state) => state.stockDetail.stockDetail;
const getStockTrade = (state) => {
  const { stockTrade } = state.stockDetail;
  // console.log(stockTrade);
  if (isArray(stockTrade)) {
    const _stockTrade = sortBy(stockTrade, ['time']);
    return _stockTrade.reverse();
  }
  return [];
};
const getStockCst = (state) => state.stockDetail.cst;
const getStockKQKD = (state) => state.stockDetail.kqkd;
const getStockCDKT = (state) => state.stockDetail.cdkt;
const getStockHis = (state) => state.stockDetail.stockHis;
const getStockNews = (state) => state.stockDetail.stockNews;
const getNewsDetail = (state) => state.stockDetail.newsDetail;
const getStockEvents = (state) => state.stockDetail.stockEvents;
const getStockManage = (state) => state.stockDetail.stockManage;
const getCompanyInfo = (state) => state.stockDetail.companyInfo;
const getAssociate = (state) => state.stockDetail.associate;
const getTransferData = (state) => state.stockDetail.transferData;
const getCollectionPrice = (state) => state.stockDetail.collectionPrice;

const getStockSource = (state) => state.cash.stockSource;
const getStockTarget = (state) => state.cash.stockTarget;
const getSourceBalance = (state) => state.cash.sourceBalance;
const getTargetBalance = (state) => state.cash.targetBalance;
const getCashTransfer = (state) => state.cash.cashTransfer;
const getCashOut = (state) => state.cash.cashOut;
const getListTransfer = (state) => state.cash.hisTransfer;
const getBankAccount = (state) => state.cash.bankAcc;
const getBankList = (state) => state.cash.bankList;
const getDebt = (state) => state.cash.debt;
const getRepayLoan = (state) => state.cash.repayLoan;
const getDebtHis = (state) => state.cash.hisDebt;
const getDebtHis2 = (state) => state.cash.hisDebt2;
const getCashInBank = (state) => state.cash.cashInBank;
const getHoldBank = (state) => state.cash.holdBank;
const getHoldList = (state) => state.cash.holdList;
const getRightList = (state) => state.cash.rightList;

const getMarginList = (state) => state.priceBoard.marginList?.data || [];

const indexList = (state) => state.priceBoard.indexList;
const worldList = (state) => state.priceBoard.worldList;
const getPart = (state) => {
  if (!state.priceBoard.partId) return null;
  return state.priceBoard.partId;

  // return sortBy(state.priceReducer.part, ['sym']);
};
const getAllStock = (state) => state.priceBoard.allStock;
const getSnapShot = (state) => state.priceBoard.snapshot;
const getSnapShotCW = (state) => state.priceBoard.snapshotCW;
const getSnapShotBond = (state) => state.priceBoard.snapshotBond;
const getPsSnapShot = (state) => state.priceBoard.psSnapshot;
const getPsIndex = (state) => state.priceBoard.psIndex;
const getAllOrder = (state) => state.priceBoard.allOrder;
const getCWList = (state) => state.priceBoard.cwList;
const getBondList = (state) => state.priceBoard.bondList;
const getPsList = (state) => state.priceBoard.psList;
const getLoleSnapshot = (state) => state.priceBoard.lole;
const getNdataSnapshot = (state) => state.priceBoard.ndataSnapshot;
const getTradeHisPs = (state) => {
  const { tradeHisPs } = state.priceBoard;
  if (isArray(tradeHisPs)) {
    const _stockTrade = sortBy(tradeHisPs, ['time']);
    return _stockTrade.reverse();
  }
  return [];
};
const getList30 = (state) => state.priceBoard.list30;
const getListEtf = (state) => state.priceBoard.listEtf;
const getIndexSummary = (state) => state.priceBoard.indSum;
const getTopInterest = (state) => state.priceBoard.topInterest;
const getTopVolume = (state) => state.priceBoard.topVolume;
const getNoiCap = (state, props) => {
  const { profile } = state.customer;
  const { noicap } = state.priceBoard;
  // console.log(profile, noicap)
  if (!profile) return null;

  if (!noicap) return profile.custIdIssuLoca;

  const _noicap = find(noicap, (o) => o.orderno === profile.custIdIssuLoca);
  return _noicap ? _noicap.name : profile.custIdIssuLoca;
};
const getListBank = (state) => {
  const { branchList } = state.priceBoard;
  if (!branchList) return null;

  const _allBankName = groupBy(branchList, 'org_abbr_nm');
  const _result = Object.keys(_allBankName).map((key) => ({
    bank: key,
    branch: _allBankName[key],
  }));
  // console.log('_allBankName', _result)
  return _result;
};

const getSummaryOrder = (state) => state.summary.ordList;
const getSummaryOrderCond = (state) => {
  // console.log(state.summary)
  return state.summary.ordCondList;
};
const getSummaryCash = (state) => {
  let { cashList } = state.summary;
  if (!cashList || !cashList.list) return null;

  let _cashList = sortBy(cashList.list, ['tranDate']);

  let bgAmt = cashList.beginAmt || 0;

  _cashList.map((item) => {
    item.beginAmt = bgAmt;
    item.afterAmt = bgAmt + item.inAmt - item.outAmt;
    bgAmt = item.afterAmt;
  });
  cashList.list = [..._cashList];
  return cashList;
};
const getSummaryStock = (state) => state.summary.stockList;
const getSummaryEvent = (state) => state.summary.event;
const getSummaryRightList = (state) => state.summary.rightList;

const getListOrderCond = (state) => {
  if (!state.ordCond.listCond || !state.ordCond.listCond.length) return [];

  return sortBy(state.ordCond.listCond, ['createddt', 'ordrNo']).reverse();
};
const getOrderCondition = (state) => ({
  cond: state.ordCond.cond,
  requesting: state.ordCond.requesting,
  success: state.ordCond.successful,
  errors: state.ordCond.errors,
});
const getOrderCondDetail = (state) => ({
  cond: state.ordCond.condDetail,
  errors: state.ordCond.condDetailErrors,
});

const getPutThroughByGroup = (state, props) => {
  const grName = props.ptGr;
  const grCode =
    grName === 'HSX'
      ? '10'
      : grName === 'HNX'
      ? '02'
      : grName === 'UPCOM'
      ? '03'
      : '10';
  const ptList = filter(state.priceBoard.ptList, (o) => o.marketID === grCode);
  return sortBy(ptList, 'time').reverse();
};

const getSymbol = (state, props) => {
  const sym = props.record.sym;
  const symbol = find(
    state.priceBoard.allStock,
    (item, i) => item.stock_code === sym
  );
  return symbol;
};

const getSymbolByStock = (state, props) => {
  // console.log(state, props)
  const symbol = find(
    state.priceBoard.allStock,
    (item, i) => item.stock_code === props.symbol
  );
  return symbol;
};

const getPinnedRow = (state, props) => {
  const { categoryId } = props;
  const _category = getCategory(state);

  const _filter = result(
    find(_category, (o) => o && o.path && o.path.endsWith(categoryId)),
    'pinnedRow'
  );
  // console.log(_filter)
  return _filter;
};

const getCatalogSelected = (state, props) => {
  const { categoryId } = props;
  // console.log(categoryId)
  if (categoryId.startsWith('nganh-')) {
    // danh muc nganh
    const _filter = find(
      DMNGANH,
      (o) => o && o.path && o.path.endsWith(categoryId)
    );
    return _filter;
  } else {
    const _category = getCategory(state);

    const _filter = find(
      _category,
      (o) => o && o.path && o.path.endsWith(categoryId)
    );

    return _filter;
  }
};

const getTypeIndex = (state) => {
  const { setting } = state.client;
  return (setting && setting.typeIndex) || 1;
};

const getTotalGD = (state) => {
  const { indexList } = state.priceBoard;
  return sumBy(
    indexList,
    (o) => o.value * (['10', '02'].includes(o.mc) ? 1 : 0)
  );
};

const getDataForeign = (state) => {
  let dataForeign = [];
  const { worldList } = state.priceBoard;

  if (worldList && !!worldList.length) {
    worldList.forEach((element) => {
      if (['Dow 30', 'S&P 500', 'Nasdaq'].indexOf(element.index) > -1) {
        dataForeign.push({
          name: element.index,
          value: `${element.last} (${element.change})`,
          cl: element.change.startsWith('+')
            ? 'i'
            : element.change.startsWith('-')
            ? 'd'
            : 'r',
        });
      }
    });
  }

  return dataForeign;
};

const getProfile = (state) => state.customer.profile;
const getCustomerBankAccount = (state) => state.customer.bankAcc;

export const makeGetSymbolByStock = () =>
  createSelector([getSymbolByStock], (symbol) => symbol);

export const makeGetSymbolState = () =>
  createSelector([getSymbol], (symbol) => symbol);

export const makeGetPinnedRow = () =>
  createSelector([getPinnedRow], (symbol) => symbol);

export const makeGetCategorySelected = () =>
  createSelector([getCatalogSelected], (symbol) => symbol);

export const makeGetTypeIndex = () =>
  createSelector([getTypeIndex], (typeIndex) => typeIndex);

export const makeDataForeign = () =>
  createSelector([getDataForeign], (dataForeign) => dataForeign);

export const makeGetTotalGD = () =>
  createSelector([getTotalGD], (totalGd) => totalGd);

export const makeGetIndexList = () =>
  createSelector([indexList], (list) => list);

export const makeGetSetting = () =>
  createSelector([getSetting], (setting) => setting);

export const makeGetStockDetail = () =>
  createSelector([getStockDetail], (stockDetail) => stockDetail);

export const makeGetStockTrade = () =>
  createSelector([getStockTrade], (stockTrade) => stockTrade);

export const makeGetStockCST = () =>
  createSelector([getStockCst], (cst) => cst);

export const makeGetStockKQKD = () =>
  createSelector([getStockKQKD], (kqkd) => kqkd);

export const makeGetStockCDKT = () =>
  createSelector([getStockCDKT], (cdkt) => cdkt);

export const makeGetStockHis = () =>
  createSelector([getStockHis], (stockHis) => stockHis);

export const makeGetStockNews = () =>
  createSelector([getStockNews], (stockNews) => stockNews);

export const makeGetNewsDetail = () =>
  createSelector([getNewsDetail], (newsDetail) => newsDetail);

export const makeGetStockEvents = () =>
  createSelector([getStockEvents], (stockEvents) => stockEvents);

export const makeGetStockManage = () =>
  createSelector([getStockManage], (stockManage) => stockManage);

export const makeGetCompanyInfo = () =>
  createSelector([getCompanyInfo], (companyInfo) => companyInfo);

export const makeGetAssociate = () =>
  createSelector([getAssociate], (associate) => associate);

export const makeGetTransferData = () =>
  createSelector([getTransferData], (transferData) => transferData);

export const makeGetToken = () => createSelector([getToken], (token) => token);
export const makeGetAuth = () => createSelector([getAuth], (auth) => auth);

export const makeGetToast = () => createSelector([getToast], (toast) => toast);

export const makeGetConfig = () =>
  createSelector([getConfig], (config) => config);

export const makeGetReceive1101 = () =>
  createSelector([getReceive1101], (receive1101) => receive1101);

export const makeGetReceive3211 = () =>
  createSelector([getReceive3211], (receive3211) => receive3211);

export const makeGetReceive3220 = () =>
  createSelector([getReceive3220], (receive3220) => receive3220);

export const makeGetListAccount = () =>
  createSelector([getListAccount], (listAccount) => listAccount);

export const makeGetDefaultAccount = () =>
  createSelector([getDefaultAccount], (defaultAccount) => defaultAccount);

export const makeGetAllStock = () =>
  createSelector([getAllStock], (allStock) => allStock);

export const makeGetPutThroughByGroup = () =>
  createSelector([getPutThroughByGroup], (ptList) => ptList);

export const makeGetCWList = () =>
  createSelector([getCWList], (cwList) => cwList);

export const makeGetBondList = () =>
  createSelector([getBondList], (bondList) => bondList);

export const makeGetPsList = () =>
  createSelector([getPsList], (psList) => psList);

export const makeGetLoleSnapshot = () =>
  createSelector([getLoleSnapshot], (lole) => lole);

export const makeGetNdataSnapshot = () =>
  createSelector([getNdataSnapshot], (ndataSnapshot) => ndataSnapshot);

export const makeGetTradeHisPs = () =>
  createSelector([getTradeHisPs], (tradeHisPs) => tradeHisPs);

export const makeGetList30 = () =>
  createSelector([getList30], (list30) => list30);

export const makeGetListEtf = () =>
  createSelector([getListEtf], (listEtf) => listEtf);

export const makeGetIndexSummary = () =>
  createSelector([getIndexSummary], (indSum) => indSum);

export const makeGetTopInterest = () =>
  createSelector([getTopInterest], (topInterest) => topInterest);

export const makeGetTopVolume = () =>
  createSelector([getTopVolume], (topVolume) => topVolume);

export const makeGetListBankName = () =>
  createSelector([getListBank], (bankName) => bankName);

export const makeGetNoiCap = () =>
  createSelector([getNoiCap], (noicap) => noicap);

export const makeGetCategory = () =>
  createSelector([getCategory], (category) => category);

export const makeGetOrderList = () =>
  createSelector([getOrderList], (orderList) => orderList);

export const makeGetListOrder = () =>
  createSelector([getListOrder], (listOrder) => listOrder);

export const makeGetCashBalance = () =>
  createSelector([getCashBalance], (cashBalance) => cashBalance);

export const makeGetStockBalance = () =>
  createSelector([getStockBalance], (stockBalance) => stockBalance);

export const makeGetPositions = () =>
  createSelector([getPositions], (positions) => positions);

export const makeGetPurchasePower = () =>
  createSelector([getPurchasePower], (purchasePower) => purchasePower);

export const makeGetNewOrder = () =>
  createSelector([getNewOrder], (newOrder) => newOrder);

export const makeGetCancelOrder = () =>
  createSelector([getCancelOrder], (cancelOrder) => cancelOrder);

export const makeGetEditOrder = () =>
  createSelector([getEditOrder], (editOrder) => editOrder);

export const makeGetEventOrder = () =>
  createSelector([getEventOrder], (event) => event);

// TODO: 02/12/2020 update get socket status
export const makeGetSocketStatus = () =>
  createSelector([getSocketStatus], (serverStatus) => serverStatus);

export const makeGetSymbolInfo = () =>
  createSelector([getSymbolInfo], (symbolInfo) => symbolInfo);

export const makeGetMatchOrder = () =>
  createSelector([getMatchOrder], (matchOrder) => matchOrder);

export const makeGetSymbolMargin = () =>
  createSelector([getSymbolMargin], (symbolMargin) => symbolMargin);

export const makeGetPart = () => createSelector([getPart], (part) => part);

export const makeGetSnapShot = () =>
  createSelector([getSnapShot], (snapshot) => snapshot);

export const makeGetSnapShotCW = () =>
  createSelector([getSnapShotCW], (snapshotCW) => snapshotCW);

export const makeGetSnapShotBond = () =>
  createSelector([getSnapShotBond], (snapshotBond) => snapshotBond);

export const makeGetPsSnapShot = () =>
  createSelector([getPsSnapShot], (psSnapshot) => psSnapshot);

export const makeGetPsIndex = () =>
  createSelector([getPsIndex], (psIndex) => psIndex);

export const makeGetAllOrder = () =>
  createSelector([getAllOrder], (allOrder) => allOrder);

export const makeGetStockSource = () =>
  createSelector([getStockSource], (stockSource) => stockSource);

export const makeGetStockTarget = () =>
  createSelector([getStockTarget], (stockTarget) => stockTarget);

export const makeGetSourceBalance = () =>
  createSelector([getSourceBalance], (sourceBalance) => sourceBalance);

export const makeGetTargetBalance = () =>
  createSelector([getTargetBalance], (targetBalance) => targetBalance);

export const makeGetCashTransfer = () =>
  createSelector([getCashTransfer], (cashTransfer) => cashTransfer);

export const makeGetCashOut = () =>
  createSelector([getCashOut], (cashOut) => cashOut);

export const makeGetHisTransfer = () =>
  createSelector([getListTransfer], (hisTransfer) => hisTransfer);

export const makeGetBankAccount = () =>
  createSelector([getBankAccount], (bankAcc) => bankAcc);

export const makeGetBankList = () =>
  createSelector([getBankList], (bankList) => bankList);

export const makeGetDebtMargin = () =>
  createSelector([getDebt], (debt) => debt);

export const makeGetRepayLoan = () =>
  createSelector([getRepayLoan], (repayLoan) => repayLoan);

export const makeGetHisDebtMargin = () =>
  createSelector([getDebtHis], (hisDebt) => hisDebt);

export const makeGetHis2DebtMargin = () =>
  createSelector([getDebtHis2], (hisDebt2) => hisDebt2);

export const makeGetCashInBank = () =>
  createSelector([getCashInBank], (cashInBank) => cashInBank);

export const makeGetHoldBank = () =>
  createSelector([getHoldBank], (holdBank) => holdBank);

export const makeGetHoldList = () =>
  createSelector([getHoldList], (holdList) => holdList);

export const makeGetRightList = () =>
  createSelector([getRightList], (rightList) => rightList);

export const makeGetMarginList = () =>
  createSelector([getMarginList], (marginList) => marginList);

export const makeGetOrderCondition = () =>
  createSelector([getOrderCondition], (ord) => ord);

export const makeGetListOrderCond = () =>
  createSelector([getListOrderCond], (listCond) => listCond);

export const makeGetCondDetail = () =>
  createSelector([getOrderCondDetail], (condDetail) => condDetail);

export const makeGetSummaryOrder = () =>
  createSelector([getSummaryOrder], (ordList) => ordList);

export const makeGetSummaryOrderCond = () =>
  createSelector([getSummaryOrderCond], (ordCondList) => ordCondList);

export const makeGetSummaryCash = () =>
  createSelector([getSummaryCash], (cashList) => cashList);

export const makeGetSummaryStock = () =>
  createSelector([getSummaryStock], (stockList) => stockList);

export const makeGetSummaryEvent = () =>
  createSelector([getSummaryEvent], (event) => event);

export const makeGetSummaryRightList = () =>
  createSelector([getSummaryRightList], (rightList) => rightList);

export const makeGetProfile = () =>
  createSelector([getProfile], (profile) => profile);

export const makeGetCustomerBankAccount = () =>
  createSelector([getCustomerBankAccount], (bankAcc) => bankAcc);

export const makeGetCollectionPrice = () =>
  createSelector([getCollectionPrice], (collectionPrice) => collectionPrice);
